import script from "./OutOfHoursPurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./OutOfHoursPurchase.vue?vue&type=script&setup=true&lang=js"

import "./OutOfHoursPurchase.vue?vue&type=style&index=0&id=4afd78a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4afd78a8"]])

export default __exports__